import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const RoundProgressBar = ({color, percentage}) => {

  return (
    <div style={{ width: 70, height: 35 }}>
      <CircularProgressbar
        value={percentage} // The current progress value
        text={`${percentage}%`} // Text to display in the center
        strokeWidth={10} // Thickness of the progress circle
        styles={{
          path: {
            stroke: color, // Color of the progress bar
            strokeLinecap: 'round',
          },
          trail: {
            stroke: '#d6d6d6', // Color of the trail (background of the circle)
          },
          text: {
            fill: color, // Text color
            fontSize: '24px', // Text size
          },
        }}
      />
    </div>
  );
};

export default RoundProgressBar;
